(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const megaNavigationItems = document.querySelectorAll('[data-mega-nav]');
  const desktopNavigation = window.matchMedia('(min-width: 991px)');

  const collapseMegaNavigation = (item) => {
    item.removeAttribute('open');
    item.querySelectorAll('[data-mega-subnav]').forEach((subnav) => subnav.removeAttribute('open'));
  };

  const closeMegaNavigation = (exception) => {
    megaNavigationItems.forEach((item) => {
      if (item !== exception) collapseMegaNavigation(item);
    });
  };

  megaNavigationItems.forEach((item) => {
    let closeTimer;
    const summary = item.querySelector(':scope > summary');

    const openItem = () => {
      if (!desktopNavigation.matches) return;
      window.clearTimeout(closeTimer);
      closeMegaNavigation(item);
      item.setAttribute('open', '');
    };

    const queueClose = () => {
      if (!desktopNavigation.matches) return;
      closeTimer = window.setTimeout(() => collapseMegaNavigation(item), 150);
    };

    item.addEventListener('mouseenter', openItem);
    item.addEventListener('mouseleave', queueClose);
    item.addEventListener('focusin', openItem);
    item.addEventListener('focusout', (event) => {
      if (!item.contains(event.relatedTarget)) queueClose();
    });

    if (summary) {
      summary.addEventListener('click', (event) => {
        if (!desktopNavigation.matches) return;
        event.preventDefault();
        openItem();
      });
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-mega-nav]')) closeMegaNavigation();

    const mobileOpen = event.target.closest('[data-mobile-nav-open]');
    if (mobileOpen) {
      const mobileNavigation = document.getElementById(mobileOpen.getAttribute('aria-controls'));
      if (mobileNavigation && !mobileNavigation.open) {
        mobileNavigation.showModal();
        mobileOpen.setAttribute('aria-expanded', 'true');
      }
    }

    const mobileClose = event.target.closest('[data-mobile-nav-close]');
    if (mobileClose) {
      const mobileNavigation = mobileClose.closest('[data-mobile-nav-dialog]');
      if (mobileNavigation) mobileNavigation.close();
    }
  });

  document.querySelectorAll('[data-mobile-nav-dialog]').forEach((dialog) => {
    const opener = document.querySelector(`[aria-controls="${dialog.id}"]`);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (opener) {
        opener.setAttribute('aria-expanded', 'false');
        opener.focus();
      }
    });
    dialog.addEventListener('toggle', () => {
      if (opener) opener.setAttribute('aria-expanded', String(dialog.open));
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMegaNavigation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["machine-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const productCache = new Map();
    const catalogCache = new WeakMap();
    const collator = new Intl.Collator(document.documentElement.lang || 'en', { numeric: true, sensitivity: 'base' });

    const decodeCatalog = async (script) => {
      if (catalogCache.has(script)) return catalogCache.get(script);
      const promise = (async () => {
        if (!('DecompressionStream' in window)) throw new Error('Catalog decompression is unavailable');
        const binary = atob(script.textContent.trim());
        const bytes = new Uint8Array(binary.length);
        for (let index = 0; index < binary.length; index += 1) bytes[index] = binary.charCodeAt(index);
        const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'));
        return JSON.parse(await new Response(stream).text());
      })();
      catalogCache.set(script, promise);
      return promise;
    };

    const unique = (values) => [...new Set(values)];
    const categoryLabel = (root, category) => category.key === 'construction' ? root.dataset.equipmentLabel : category.label;

    const createOption = (value, label) => {
      const option = document.createElement('option');
      option.value = String(value);
      option.textContent = label;
      return option;
    };

    const formatPrice = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency',
      currency
    }).format(Number(cents) / 100);

    const fetchProduct = async (base, handle) => {
      if (productCache.has(handle)) return productCache.get(handle);
      const promise = fetch(base + 'products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      }).then((response) => {
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      });
      productCache.set(handle, promise);
      return promise;
    };

    const buildProductCard = (root, product, base, currency) => {
      const article = document.createElement('article');
      article.className = 'machine-finder__product';

      const media = document.createElement('a');
      media.className = 'machine-finder__product-media';
      media.href = base + 'products/' + product.handle;
      if (product.featured_image) {
        const image = document.createElement('img');
        image.src = product.featured_image;
        image.alt = product.title;
        image.loading = 'lazy';
        media.append(image);
      }

      const copy = document.createElement('div');
      copy.className = 'machine-finder__product-copy';
      const title = document.createElement('h4');
      title.textContent = product.title;
      const price = document.createElement('p');
      price.className = 'machine-finder__product-price';
      price.textContent = (product.price_varies ? root.dataset.fromText + ' ' : '') + formatPrice(product.price, currency);
      const link = document.createElement('a');
      link.className = 'machine-finder__product-link';
      link.href = media.href;
      link.textContent = root.dataset.openProductText;
      copy.append(title, price, link);
      article.append(media, copy);
      return article;
    };

    const initRoot = async (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const script = root.querySelector('[data-machine-data]');
      let modernDesigns = JSON.parse(root.querySelector('[data-modern-designs]')?.textContent || '[]');
      let modernIndex;
      const loadModernIndex = () => modernIndex ||= (async () => {
        const fitment = await window.BPSnowFitmentReady;
        modernDesigns = await fitment.loadDesignIndex(root);
      })().catch(error => { modernIndex = null; throw error; });
      const categoryButtons = [...root.querySelectorAll('[data-category-key]')];
      if (!categoryButtons.length && !new URLSearchParams(window.location.search).has('finder_category')) {
        root.querySelector('[data-finder-status]').textContent = '';
        return;
      }
      const picker = root.querySelector('[data-finder-picker]');
      const snowMakes = root.querySelector('[data-snow-makes]');
      const mxMakes = root.querySelector('[data-mx-makes]');
      const reset = root.querySelector('[data-finder-reset]');
      const status = root.querySelector('[data-finder-status]');
      const loading = root.querySelector('[data-results-loading]');
      const results = root.querySelector('[data-finder-results]');
      const resultsGrid = root.querySelector('[data-results-grid]');
      const resultsCount = root.querySelector('[data-results-count]');
      const request = root.querySelector('[data-request-form]');
      const selectionTitle = root.querySelector('[data-selection-title]');
      const selectionSummary = root.querySelector('[data-selection-summary]');
      const upload = root.querySelector('[data-request-upload]');
      const uploadName = root.querySelector('[data-upload-name]');
      const trackField = root.querySelector('[data-track-field]');
      const selects = {
        make: root.querySelector('[data-finder-select="make"]'),
        year: root.querySelector('[data-finder-select="year"]'),
        model: root.querySelector('[data-finder-select="model"]'),
        track: root.querySelector('[data-finder-select="track"]')
      };
      const contactFields = Object.fromEntries(
        [...root.querySelectorAll('[data-contact-field]')].map((field) => [field.dataset.contactField, field])
      );
      const placeholders = Object.fromEntries(
        Object.entries(selects).map(([name, select]) => [name, select.options[0].textContent])
      );
      const state = { category: null, make: null, year: null, model: null, track: null };
      const base = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
      const currency = root.dataset.currency || 'CAD';
      let catalog;
      let searchSerial = 0;

      const transition = (callback) => {
        if (document.startViewTransition) document.startViewTransition(callback);
        else callback();
      };

      const setStatus = (message) => {
        status.textContent = message || '';
      };

      const clearSelect = (name, disabled = true) => {
        const select = selects[name];
        select.replaceChildren(createOption('', placeholders[name]));
        select.disabled = disabled;
        select.value = '';
        state[name] = null;
      };

      const resetTrack = () => {
        clearSelect('track');
        trackField.hidden = true;
      };

      const rowsFor = (through) => catalog.rows.filter((row) => {
        if (state.category !== null && row[0] !== state.category) return false;
        if (through === 'category') return true;
        if (state.make !== null && row[1] !== state.make) return false;
        if (through === 'make') return true;
        if (state.year !== null && row[2] !== state.year) return false;
        if (through === 'year') return true;
        if (state.model !== null && row[3] !== state.model) return false;
        if (through === 'model') return true;
        return true;
      });

      const trackSizeFor = (row) => {
        const label = catalog.trims[row[4]] || '';
        const match = label.match(/(?:^|[^\d])(1[2-8]\d)\s*(?:"|″|''|in(?:ches)?\b)/i);
        return match ? match[1] : null;
      };

      const productTrackSizeFor = (handle) => {
        const match = handle.match(/(?:tunnel|track)[-_ ]?(1[2-8]\d)(?:\b|$)|\b(1[2-8]\d)[-_ ]?(?:tunnel|track)(?:\b|$)/i);
        return match ? (match[1] || match[2]) : null;
      };

      const trackSizesForModel = () => unique(
        rowsFor('model').flatMap((row) => {
          const rowSize = trackSizeFor(row);
          return rowSize ? [rowSize] : row[5].map((index) => productTrackSizeFor(catalog.products[index])).filter(Boolean);
        })
      ).sort((a, b) => Number(a) - Number(b));

      const updateContact = () => {
        const category = state.category === null ? '' : categoryLabel(root, catalog.categories[state.category]);
        const make = state.make === null ? '' : catalog.makes[state.make];
        const year = state.year || '';
        const model = state.model === null ? '' : catalog.models[state.model];
        const track = state.track === null ? '' : state.track + '″';
        const values = { category, make, year, model, track };
        Object.entries(values).forEach(([name, value]) => {
          if (contactFields[name]) contactFields[name].value = value;
        });
        const summary = [category, make, year, model, track].filter(Boolean);
        if (selectionSummary && summary.length) selectionSummary.textContent = summary.join(' / ');
      };

      const hideOutcome = () => {
        searchSerial += 1;
        loading.hidden = true;
        results.hidden = true;
        resultsGrid.replaceChildren();
        if (!request.querySelector('.machine-finder__form-message')) request.hidden = true;
      };

      const populate = (name, values, labels, sorter) => {
        clearSelect(name, false);
        values.sort(sorter).forEach((value) => selects[name].append(createOption(value, labels[value])));
      };

      const showRequest = () => {
        results.hidden = true;
        loading.hidden = true;
        request.hidden = false;
        updateContact();
        request.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      };

      const showProducts = async () => {
        hideOutcome();
        const lookup = searchSerial;
        updateContact();
        const rows = rowsFor('model').filter((row) => !state.track || !trackSizeFor(row) || trackSizeFor(row) === state.track);
        const legacy = unique(rows.flatMap((row) => row[5])).filter((index) => {
          const size = productTrackSizeFor(catalog.products[index]);
          return !state.track || !size || size === state.track;
        }).map((index) => catalog.products[index]).filter((handle) => !(catalog.modern_products || []).includes(handle));
        let modern = { handles: [], model: '' };
        {
          loading.hidden = false;
          const fitment = await window.BPSnowFitmentReady?.catch(() => null);
          if (lookup !== searchSerial) return;
          try{await loadModernIndex();}catch(error){loading.hidden=true;showRequest();setStatus(root.dataset.catalogError);return;}
          if (lookup !== searchSerial) return;
          modern = fitment?.matchCatalogDesigns(modernDesigns, catalog.categories[state.category].key, catalog.makes[state.make], state.year, catalog.models[state.model], state.track) || modern;
        }
        const handles = unique([...modern.handles, ...legacy]);
        if (!handles.length) {
          showRequest();
          return;
        }
        const params = new URLSearchParams({
          category: categoryLabel(root, catalog.categories[state.category]),
          category_key: catalog.categories[state.category].key,
          make: catalog.makes[state.make],
          year: state.year,
          model: catalog.models[state.model],
          track_size: state.track || '',
          products: handles.join(',')
        });
        if (modern.handles.length && modern.model) params.set('modern_model', modern.model);
        const previewId = root.dataset.previewThemeId || new URLSearchParams(location.search).get('preview_theme_id');
        if (previewId) params.set('preview_theme_id', previewId);
        loading.hidden = false;
        window.location.assign(root.dataset.resultsUrl + '?' + params.toString());
      };
      const prepareTrackStep = () => {
        const sizes = trackSizesForModel();
        if (!sizes.length) {
          trackField.hidden = true;
          showProducts();
          return;
        }
        const labels = Object.fromEntries(sizes.map((size) => [size, size + '″']));
        populate('track', sizes, labels, (a, b) => Number(a) - Number(b));
        trackField.hidden = false;
      };

      categoryButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          if(!catalog)return;
          const categoryIndex = catalog.categories.findIndex((category) => category.key === button.dataset.categoryKey);
          if (categoryIndex < 0) return;
          transition(() => {
            state.category = categoryIndex;
            categoryButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
            clearSelect('make');
            clearSelect('year');
            clearSelect('model');
            resetTrack();
            hideOutcome();
            const makeIndexes = unique(rowsFor('category').map((row) => row[1]));
            populate('make', makeIndexes, catalog.makes, (a, b) => collator.compare(catalog.makes[a], catalog.makes[b]));
            picker.hidden = false;
            snowMakes.hidden = catalog.categories[categoryIndex].key !== 'snowmobile';
            mxMakes.hidden = catalog.categories[categoryIndex].key !== 'dirt-bike';
            selectionTitle.textContent = categoryLabel(root, catalog.categories[categoryIndex]);
            updateContact();
            setStatus('');
          });
          if (matchMedia('(max-width: 700px)').matches) (!snowMakes.hidden ? snowMakes : !mxMakes.hidden ? mxMakes : picker).scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      selects.make.addEventListener('change', () => {
        state.make = selects.make.value === '' ? null : Number(selects.make.value);
        clearSelect('year');
        clearSelect('model');
        resetTrack();
        hideOutcome();
        if (state.make !== null) {
          const years = unique(rowsFor('make').map((row) => row[2]));
          const labels = Object.fromEntries(years.map((year) => [year, year]));
          populate('year', years, labels, (a, b) => {
            if (a === 'Current') return -1;
            if (b === 'Current') return 1;
            return Number(b) - Number(a);
          });
        }
        updateContact();
      });

      selects.year.addEventListener('change', () => {
        state.year = selects.year.value || null;
        clearSelect('model');
        resetTrack();
        hideOutcome();
        if (state.year !== null) {
          const modelIndexes = unique(rowsFor('year').map((row) => row[3]));
          populate('model', modelIndexes, catalog.models, (a, b) => collator.compare(catalog.models[a], catalog.models[b]));
          selects.model.append(createOption('not-listed', root.dataset.modelNotListed));
        }
        updateContact();
      });

      selects.model.addEventListener('change', () => {
        resetTrack();
        hideOutcome();
        if (selects.model.value === 'not-listed') {
          state.model = null;
          updateContact();
          showRequest();
          return;
        }
        state.model = selects.model.value === '' ? null : Number(selects.model.value);
        updateContact();
        if (state.model !== null) prepareTrackStep();
      });

      selects.track.addEventListener('change', () => {
        state.track = selects.track.value || null;
        hideOutcome();
        updateContact();
        if (state.track !== null) showProducts();
      });

      reset.addEventListener('click', () => {
        transition(() => {
          state.category = null;
          clearSelect('make');
          clearSelect('year');
          clearSelect('model');
          resetTrack();
          categoryButtons.forEach((button) => button.setAttribute('aria-pressed', 'false'));
          picker.hidden = true;
          snowMakes.hidden = true;
          mxMakes.hidden = true;
          hideOutcome();
          setStatus('');
        });
      });

      if (upload) {
        upload.addEventListener('change', () => {
          const file = upload.files && upload.files[0];
          if (!file) {
            uploadName.textContent = '';
            return;
          }
          if (file.size > 10 * 1024 * 1024) {
            upload.value = '';
            uploadName.textContent = root.dataset.uploadTooLarge;
            return;
          }
          uploadName.textContent = file.name;
        });
      }

      try {
        catalog = await decodeCatalog(script);
        try {
          const vintageProducts = await window.BPVintageCatalog.load(root);
          catalog = window.BPVintageCatalog.enrich(catalog, vintageProducts);
        } catch (error) {
          // Preserve the bundled finder for other categories during a catalog outage.
          console.warn('Published vintage index unavailable', error);
        }
        if (!window.BPSnowFitmentReady) {
          const sledScript = root.querySelector('script[src*="bp-snow-fitment.js"]');
          if (sledScript) await new Promise((resolve) => {
            const timer = setTimeout(resolve, 8000);
            const ready = () => { clearTimeout(timer); resolve(); };
            sledScript.addEventListener('load', ready, { once: true });
            sledScript.addEventListener('error', ready, { once: true });
          });
        }
        const sledFitment = await window.BPSnowFitmentReady?.catch(() => null);
        if (sledFitment?.enrichCatalog) catalog = sledFitment.enrichCatalog(catalog);
        categoryButtons.forEach((button) => { button.disabled = false; });
        setStatus('');
        const saved = new URLSearchParams(window.location.search);
        const categoryValue = saved.get('finder_category');
        if (categoryValue) {
          const categoryIndex = catalog.categories.findIndex((item) => item.key === categoryValue || item.label === categoryValue);
          if (categoryIndex >= 0) {
            state.category = categoryIndex;
            categoryButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.categoryKey === catalog.categories[categoryIndex].key)));
            picker.hidden = false;
            snowMakes.hidden = catalog.categories[categoryIndex].key !== 'snowmobile';
            mxMakes.hidden = catalog.categories[categoryIndex].key !== 'dirt-bike';
            selectionTitle.textContent = categoryLabel(root, catalog.categories[categoryIndex]);
            const makeIndexes = unique(rowsFor('category').map((row) => row[1]));
            populate('make', makeIndexes, catalog.makes, (a, b) => collator.compare(catalog.makes[a], catalog.makes[b]));
            const makeIndex = makeIndexes.find((index) => catalog.makes[index] === saved.get('finder_make'));
            if (makeIndex !== undefined) {
              state.make = makeIndex;
              selects.make.value = String(makeIndex);
              const years = unique(rowsFor('make').map((row) => row[2]));
              populate('year', years, Object.fromEntries(years.map((year) => [year, year])), (a, b) => Number(b) - Number(a));
              const year = saved.get('finder_year');
              if (years.includes(year)) {
                state.year = year;
                selects.year.value = year;
                const modelIndexes = unique(rowsFor('year').map((row) => row[3]));
                populate('model', modelIndexes, catalog.models, (a, b) => collator.compare(catalog.models[a], catalog.models[b]));
                selects.model.append(createOption('not-listed', root.dataset.modelNotListed));
                const modelIndex = modelIndexes.find((index) => catalog.models[index] === saved.get('finder_model'));
                if (modelIndex !== undefined) {
                  state.model = modelIndex;
                  selects.model.value = String(modelIndex);
                  const sizes = trackSizesForModel();
                  if (sizes.length) {
                    populate('track', sizes, Object.fromEntries(sizes.map((size) => [size, size + '″'])), (a, b) => Number(a) - Number(b));
                    trackField.hidden = false;
                    const savedTrack = saved.get('finder_track_size');
                    if (sizes.includes(savedTrack)) {
                      state.track = savedTrack;
                      selects.track.value = savedTrack;
                    }
                  }
                }
              }
            }
            updateContact();
            if (window.location.hash === '#machine-finder') picker.scrollIntoView({ block: 'start' });
          }
        }
      } catch (error) {
        setStatus(root.dataset.catalogError);
      }
    };

    const init = (scope = document) => {
      if (scope.matches?.('[data-machine-finder]')) initRoot(scope);
      scope.querySelectorAll('[data-machine-finder]').forEach(initRoot);
    };

    init();
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    window.addEventListener('pageshow', () => init());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-machine-results"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-machine-results]').forEach(async (root) => {
      const params = new URLSearchParams(location.search);
      const values = Object.fromEntries(['category', 'make', 'year', 'model', 'track_size'].map((key) => [key, params.get(key) || '']));
      const summary = [values.year, values.make, values.model].filter(Boolean).join(' ') +
        (values.track_size ? ' · ' + values.track_size + '″ ' + root.dataset.trackSuffix : '');
      root.querySelector('[data-machine-summary]').textContent = summary;
      const olderSource = params.get('source') === 'older';
      const collectionSource = params.get('source') === 'collection';
      if (olderSource) {
        root.querySelector('[data-results-title]').textContent = root.dataset.olderTitle;
        root.querySelector('[data-results-eyebrow]').textContent = root.dataset.olderEyebrow;
      } else if (collectionSource) {
        root.querySelector('[data-results-title]').textContent = 'Matching ' + (values.category || 'machine') + ' graphics';
        root.querySelector('[data-results-eyebrow]').textContent = 'Fitment matches';
      }
      root.querySelector('[data-request-summary]').textContent = summary;
      const collectionHandle = params.get('source_collection') || '';
      const validCollection = /^[a-z0-9][a-z0-9-]*(?:graphics(?:-1)?|decals|packages|accessories)$/.test(collectionHandle);
      const back = (olderSource || collectionSource) && validCollection
        ? new URL((root.dataset.rootUrl || '/').replace(/\/?$/, '/') + 'collections/' + collectionHandle, location.origin)
        : new URL(root.querySelector('[data-change-machine]').href);
      if ((olderSource || collectionSource) && validCollection) back.hash = 'older-model-finder';
      const previousSelection = {
        finder_category: params.get('category_key') || values.category,
        finder_make: values.make,
        finder_year: values.year,
        finder_model: values.model,
        finder_track_size: values.track_size
      };
      Object.entries(previousSelection).forEach(([key, value]) => {
        if (value) back.searchParams.set(key, value);
      });
      const previewId = params.get('preview_theme_id');
      if (previewId) back.searchParams.set('preview_theme_id', previewId);
      root.querySelector('[data-change-machine]').href = back.toString();
      Object.entries(values).forEach(([key, value]) => {
        const field = root.querySelector('[data-request-' + key + ']');
        if (field) field.value = value;
      });
      const status = root.querySelector('[data-machine-status]');
      const grid = root.querySelector('[data-machine-grid]');
      const request = root.querySelector('[data-machine-request]');
      const handles = [...new Set((params.get('products') || '').split(',').filter((handle) => /^[a-z0-9][a-z0-9-]*$/.test(handle)))];
      if (!handles.length) {
        status.textContent = root.dataset.emptyText;
        request.hidden = false;
        return;
      }
      const base = (root.dataset.rootUrl || '/').replace(/\/?$/, '/');
      const settled = await Promise.allSettled(handles.map(async (handle) => {
        const response = await fetch(base + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Product unavailable');
        return response.json();
      }));
      const isModern = (product) => (Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(','))
        .some((tag) => tag.trim().toLowerCase() === 'catalog-modern');
      const products = settled.filter((item) => item.status === 'fulfilled').map((item) => item.value)
        .filter((product) => {
          if(!product.available || (Array.isArray(product.tags)?product.tags:String(product.tags||'').split(',')).some(tag=>tag.trim()==='not-for-sale'))return false;
          if (params.get('category_key') !== 'snowmobile' || Number(values.year) >= 2011) return true;
          const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
          return !tags.some(tag => tag.trim().toLowerCase() === 'template-purchasable');
        })
        .sort((a, b) => Number(isModern(b)) - Number(isModern(a)));
      if (!products.length) {
        status.textContent = root.dataset.emptyText;
        request.hidden = false;
        return;
      }
      const count = root.querySelector('[data-machine-count]');
      count.textContent = products.length + ' ' + root.dataset.countLabel;
      count.hidden = false;
      const currency = root.dataset.currency || 'CAD';
      const formatPrice = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency }).format(Number(cents) / 100);
      const fitment = new URLSearchParams();
      ['category_key', 'make', 'year', 'model', 'track_size', 'preview_theme_id'].forEach(key => {
        if (params.get(key)) fitment.set(key, params.get(key));
      });
      if (root.dataset.previewThemeId) fitment.set('preview_theme_id',root.dataset.previewThemeId);
      products.forEach((product) => {
        const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
        const modern = isModern(product);
        const productFitment = new URLSearchParams(fitment);
        const group=tags.find(tag=>tag.startsWith('fitgroup-'))?.slice(9);
        if(modern&&group){productFitment.set('chassis',group);const family={snowmobile:'snow','dirt-bike':'motocross',sxs:'sxs',atv:'atv',pwc:'pwc',construction:'equipment'}[params.get('category_key')];if(family)productFitment.set('machine_key',family+'/'+(tags.find(tag=>tag.startsWith('make-'))?.slice(5)||String(values.make).toLowerCase().replace(/[^a-z0-9]+/g,'-'))+'/'+group);}
        const productUrl = base + 'products/' + encodeURIComponent(product.handle) + (productFitment.size ? '?' + productFitment.toString() : '');
        const typeTag = tags.map(tag => tag.trim().toLowerCase()).find(tag => tag.startsWith('decal-type-snowmobile-'));
        const typeLabels = {
          'decal-type-snowmobile-body-graphics': root.dataset.bodyType,
          'decal-type-snowmobile-tunnel-decals': root.dataset.tunnelType,
          'decal-type-snowmobile-hood-and-front-decals': root.dataset.hoodType
        };
        const typeLabel = typeLabels[typeTag] || String(product.type || '').replace(/^Snowmobile\s+/i, '') || root.dataset.graphicsType;
        const displayTitle = product.title.replace(/\s+Custom (?:Body, Hood and Side Graphics|Tunnel Decals|Hood and Front Decals)$/i, '').trim();
        const card = document.createElement('article');
        card.className = 'machine-results__card' + (modern ? ' machine-results__card--modern' : '');
        const media = document.createElement('a');
        media.className = 'machine-results__media';
        media.href = productUrl;
        media.setAttribute('aria-label', root.dataset.openProductText + ': ' + product.title);
        const image = document.createElement('img');
        if (product.featured_image) {
          image.src = product.featured_image;
          image.alt = product.title;
          image.loading = 'lazy';
          media.append(image);
        }
        const copy = document.createElement('div');
        copy.className = 'machine-results__copy';
        const type = document.createElement('span');
        type.className = 'machine-results__type';
        type.textContent = typeLabel;
        const title = document.createElement('h2');
        const titleLink = document.createElement('a');
        titleLink.href = productUrl;
        titleLink.textContent = displayTitle;
        titleLink.title = product.title;
        title.append(titleLink);
        const price = document.createElement('p');
        price.className = 'machine-results__price';
        if (Number(product.price) > 0) {
          price.textContent = (product.price_varies ? root.dataset.fromText + ' ' : '') + formatPrice(product.price);
        } else {
          price.classList.add('machine-results__price--pending');
          price.textContent = root.dataset.pricePending;
        }
        const link = document.createElement('a');
        link.className = 'machine-results__action';
        link.href = productUrl;
        link.textContent = root.dataset.openProductText;
        link.setAttribute('aria-label', root.dataset.openProductText + ': ' + product.title);
        copy.append(type, title);
        if(tags.some(tag=>['preset-design','Vintage'].includes(tag.trim()))){const ready=document.createElement('span');ready.className='machine-results__ready';ready.textContent=root.dataset.readyLabel;copy.append(ready);}
        if (modern && !tags.includes('preset-design') && Array.isArray(product.variants) && product.variants.length > 1) {
          const colors = document.createElement('div');
          colors.className = 'machine-results__colors';
          colors.setAttribute('role', 'group');
          colors.setAttribute('aria-label', product.title + ' colors');
          const shownColors = new Set();
          product.variants.forEach((variant, index) => {
            if (!variant.available) return;
            const color = variant.option1 || variant.title;
            if (shownColors.has(color)) return;
            const photo = variant.featured_image?.src || variant.featured_image?.url || product.images?.[index];
            if (!photo) return;
            shownColors.add(color);
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'machine-results__color';
            button.setAttribute('aria-label', variant.option1 || variant.title);
            button.setAttribute('aria-pressed', String(shownColors.size === 1));
            const thumbnail = document.createElement('img');
            thumbnail.src = photo;
            thumbnail.alt = '';
            thumbnail.loading = 'lazy';
            button.append(thumbnail);
            button.addEventListener('click', () => {
              image.src = photo;
              colors.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
              const variantUrl = new URL(productUrl, location.origin);
              variantUrl.searchParams.set('variant', variant.id);
              media.href = titleLink.href = link.href = variantUrl.toString();
            });
            colors.append(button);
          });
          if (colors.childElementCount > 1) copy.append(colors);
        }
        copy.append(price, link);
        card.append(media, copy);
        grid.append(card);
      });
      status.textContent = '';
      grid.hidden = false;
      request.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
